import { render, staticRenderFns } from "./rightOperate.vue?vue&type=template&id=735d1e50&scoped=true&"
import script from "./rightOperate.vue?vue&type=script&lang=js&"
export * from "./rightOperate.vue?vue&type=script&lang=js&"
import style0 from "./rightOperate.vue?vue&type=style&index=0&id=735d1e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735d1e50",
  null
  
)

component.options.__file = "rightOperate.vue"
export default component.exports